import { v4 as uuidV4 } from 'uuid';
import type { SpmData } from './type';

/**
 * 数组原型添加findLastIndex
 */
(Array.prototype as any)._jt_findLastIndex = function (callback: any) {
  try {
    if (!this) return; // 防止报错
    for (let i = this.length - 1; i >= 0; i--) {
      if (callback(this[i], i, this)) {
        return i;
      }
    }
    return -1;
  } catch { }
};

/**
 * 数组原型添加jimoTrackerPush，添加非空判断
 */
(Array.prototype as any)._jt_push = function (...args: any[]) {
  try {
    if (this && args[0]) {
      Array.prototype.push.apply(this, args);
    }
  } catch { }
};

/**
 * 替换url的指定参数，如果没有会新增
 * @param {*} url 需要处理的url
 * @param {*} name 参数名称
 * @param {*} value 替换的值
 */
export const replaceOrAddQueryString = (url: string, name: string, value: any) => {
  try {
    const re = new RegExp(name + '=[^&]*', 'g');
    if (re.test(url)) {
      return url.replace(re, name + '=' + value);
    } else {
      return url + '&' + name + '=' + value;
    }
  } catch { }
};

/**
 * 获取url的指定参数
 * @param {*} name 参数名称
 * @param {*} url 需要处理的url,可不传
 */
export const getQueryString = (name: string, url = '') => {
  try {
    // 获取URL参数
    const reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)');
    const r = (url || window.location.search.substr(1)).match(reg); // 正则不匹配问号需去掉
    return r != null ? r[2] : '';
  } catch { }
  return '';
};

/**
 * 删除url的指定参数
 * @param {*} url 需要处理的url
 * @param {*} name 参数名称
 */
export const deleteQueryString = (url: string, name: string) => {
  try {
    const re = new RegExp('&?' + name + '=[^&]*', 'g');
    return url.replace(re, '');
  } catch { }
};

/**
 * 设置当前会话指纹
 */
export const getUuid = () => {
  try {
    return uuidV4().replace(/-/g, '');
  } catch { }
};

// 是否为mac系统（包含iphone手机）
export const isMac = () => /macintosh|mac os x/i.test(navigator.userAgent);

// 按大数据要求对路径进行处理
export const getValidPath = (pathname = '') => {
  let newPathname = decodeURIComponent(pathname);

  // 兼容任务模块特殊路径
  if (newPathname.includes('/{')) {
    newPathname = newPathname.split('/{')[0];
  }
  // 将路径中的 /corpId/xxx/agentId/xxx 替换成 /
  return newPathname.replace(/\/corpId\/.*\/agentId\/\d*\//, '/');
};

// 生成 router key 源自 react-router v5
export const createKey = () => {
  return Math.random().toString(36).substr(2, 8);
};

export const getSpm = (data: SpmData = {}) => {
  const { projectDesc = '', pageDesc = '', blockDesc = '', buttonDesc = '', buttonTime = 0 } = data;

  const placeA = projectDesc ? projectDesc : _jt_._mainObj.project_desc;
  const placeB = pageDesc ? pageDesc : _jt_.getSpmPathName();
  const placeC = blockDesc
    ? blockDesc
    : _jt_.preEventData.event_type === 'click' && _jt_.preEventData.block_desc
      ? _jt_.preEventData.block_desc
      : '0';
  const placeD = buttonDesc
    ? buttonDesc
    : _jt_.preEventData.event_type === 'click' && _jt_.preEventData.button_desc
      ? _jt_.preEventData.button_desc
      : '0';
  const placeE = buttonTime ? buttonTime : new Date().getTime();

  return `${placeA}.${placeB}.${placeC}.${placeD}.${placeE}`;
};

// 对跨应用或其他外部地址链接设置大数据专用 spm 埋点参数 (url参数中不能有 / 否则微信分享会失败)
export const getUrlWithSpmParams = (url = location.href) => {
  let newUrl: any = url;
  newUrl = deleteQueryString(newUrl, '_jt_preSpm');
  const preSpm = getSpm().replace(new RegExp(/\//gi), '___');
  newUrl = replaceOrAddQueryString(newUrl, '_jt_preSpm', encodeURIComponent(preSpm));
  return newUrl;
};

// 对分享链接设置大数据专用分享埋点参数 (url参数中不能有 / 否则微信分享会失败)
export const getShareUrlWithJimoParams = ({
  url = location.href,
  shareType = 0,
  shareEventSeq = -1,
  shareTime = 0,
  userInfo = {},
}) => {
  if (shareEventSeq === -1) {
    console.log('%c[jimo-tracker-sdk]', consoleLogStyle, `shareEventSeq 未设置，请检查设置分享链接前是否上报埋点`);
  }
  if (!shareTime) {
    console.log('%c[jimo-tracker-sdk]', consoleLogStyle, `shareTime 未设置，请检查设置分享链接前是否上报埋点`);
  }
  if (!shareType) {
    console.log('%c[jimo-tracker-sdk]', consoleLogStyle, `shareType 未设置，请检查设置分享链接前是否上报埋点`);
  }

  const { openId = '' } = userInfo as any;
  let newUrl: any = url;
  newUrl = deleteQueryString(newUrl, '_jt_firstShare');
  newUrl = deleteQueryString(newUrl, '_jt_preShare');

  let firstShareSpm = ``;
  const firstShareData = _jt_.getFirstShareData();
  console.log('vue埋点数据666666', firstShareData);
  if (firstShareData.first_share_sess_id) {
    firstShareSpm = `${firstShareData.first_share_sess_id}_${firstShareData.first_share_event_seq}_${firstShareData.first_share_type}_${firstShareData.first_share_t}`;
  } else {
    firstShareSpm = `${_jt_._mainObj.session_id}_${shareEventSeq}_${shareType}_${shareTime}`;
  }
  newUrl = replaceOrAddQueryString(newUrl, '_jt_firstShare', encodeURIComponent(firstShareSpm));

  const preShareSpm = `${_jt_._mainObj.session_id}_${shareEventSeq}_${shareType}_${shareTime}_${openId}`;
  newUrl = replaceOrAddQueryString(newUrl, '_jt_preShare', encodeURIComponent(preShareSpm));
  console.log('vue埋点数据6666668', newUrl);

  return newUrl;
};

export const consoleLogStyle = 'color: white; background-color: red; padding: 3px; display: block; border-radius: 2px;';
